import { AxiosResponse } from "axios";
import CategoryInfo from "../../model/categoryInfo";
import api from "../../utils/api";

export function getCategoriesInfo(setCategories: Function): Promise<AxiosResponse<CategoryInfo>> {
    const path: string = "/categories";
    return api.get(
        path,
    ).then((response) => {
        const categories : CategoryInfo[] = response.data;
        setCategories(categories);
        return response;
    },
    ).catch((err) => {
        throw err;
    });
}
